// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetSegmentCohortEngagementsResult = objectOf({
  engagements: objectOf({
    campaigns: arrayOf(
      objectOf({
        id: string,
        name: string,
        status: string,
      })
    ),
    canvases: arrayOf(
      objectOf({
        id: string,
        name: string,
        status: string,
      })
    ),
    canvas_steps: arrayOf(
      objectOf({
        id: string,
        name: string,
        status: string,
      })
    ),
    segments: arrayOf(
      objectOf({
        id: string,
        name: string,
        status: string,
      })
    ),
  }),
});
